module.exports = __webpack_public_path__ + "img/777.402406f9.png";